import { get } from 'lodash';
import { parsePath } from '@truqc/content-path';
import store from '../reducers/storeRegistration';
import { actionRegistrar } from '../actions/entityActionRegistrar';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';

/**
 * this sets localy (client specific) cached variables
 * and then forces a content/format re-evaluation
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const name = await evaluateSource(source.name, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  const state = store.getState();
  const _state$entityName$edi = state[entityName].editorCache,
    editorCache = _state$entityName$edi === void 0 ? {} : _state$entityName$edi;
  const cachedVar = get(editorCache, parsePath(name));
  if (cachedVar !== value) {
    const entityActions = actionRegistrar(entityName);
    await store.dispatch(entityActions.setEditorCacheValue(name, value));
  }
};
export default {
  evaluate
};